import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
const failures = [{
  title: 'Dietas de 1,200 calorías',
  reason: "Fallan porque estresan al cuerpo, elevando el cortisol y ordenando al cuerpo 'guardar grasa' por miedo a la hambruna."
}, {
  title: 'Cardio Excesivo (Zumba/Correr)',
  reason: 'Aumenta el impacto en las articulaciones y eleva la inflamación sistémica en mujeres maduras, bloqueando la pérdida de peso.'
}, {
  title: 'Pastillas Quema-grasa',
  reason: 'Solo aceleran el corazón y causan ansiedad sin arreglar la raíz hormonal del problema. Efecto rebote garantizado.'
}];
export function WhyOthersFail() {
  return <section className="py-20 bg-white" data-id="element-215">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-216">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-217">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-218">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#1a4d3e] mb-6" data-id="element-219">
              Por qué todo lo que has intentado ha fallado
            </h2>
            <p className="text-lg text-gray-600 mb-8" data-id="element-220">
              No es tu culpa. Las soluciones tradicionales están diseñadas para
              hombres o mujeres de 20 años. A los 40+, tu cuerpo sigue reglas
              diferentes.
            </p>

            <div className="space-y-6" data-id="element-221">
              {failures.map((item, index) => <div key={index} className="flex items-start p-4 bg-red-50 rounded-lg border border-red-100" data-id="element-222">
                  <XCircle className="text-red-500 mt-1 mr-4 flex-shrink-0" size={24} data-id="element-223" />
                  <div data-id="element-224">
                    <h4 className="font-bold text-[#2d2d2d] text-lg mb-1" data-id="element-225">
                      {item.title}
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-226">{item.reason}</p>
                  </div>
                </div>)}
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="relative h-full min-h-[400px] bg-[#faf8f5] rounded-2xl overflow-hidden flex items-center justify-center p-8" data-id="element-227">
            <div className="text-center" data-id="element-228">
              <div className="inline-block p-6 rounded-full bg-white shadow-xl mb-6" data-id="element-229">
                <span className="text-6xl" data-id="element-230">🛑</span>
              </div>
              <h3 className="text-2xl font-serif font-bold text-[#1a4d3e] mb-4" data-id="element-231">
                Deja de luchar contra tu cuerpo
              </h3>
              <p className="text-gray-600 max-w-md mx-auto" data-id="element-232">
                Forzar a tu cuerpo con métodos agresivos solo empeora el
                desbalance hormonal. Necesitas trabajar CON tu fisiología, no
                contra ella.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}